module.exports = __webpack_public_path__ + "media/images/common/project_select_bg-d827a62b4adb20a78113db7306bdb113.png";